export const SITE_URL = "https://www.improvey.agency";

export const SITE = {
  name: "Improve Yourself",
  legalName: "Improve Yourself",
  email: "contacto@improvey.agency",
  phone: "+51 956 255 755",
  whatsapp: "51956255755", // sin +
  whatsappMsg: "Hola, quiero activar mi marca. ¿Coordinamos una propuesta?",
  ruc: "20602827314",
  city: "Lima",
  country: "Perú",
  foundingYear: "2018",
  // Zona de trabajo: todo el Perú, con base en Lima. Visible en el pie, en el schema
  // LocalBusiness y en /llms.txt: un solo texto para que no se contradigan.
  coverage: "Todo el Perú, con base en Lima (Lima Metropolitana y Callao)",
  // Ficha de Google Business Profile (cid de seo_ficha_local). Va en el `sameAs` del
  // schema para que los buscadores y asistentes asocien la marca con este dominio:
  // «Improve Yourself» por sí solo es una frase genérica.
  googleBusinessUrl: "https://maps.google.com/?cid=17863069529000178799",
  description:
    "Improve Yourself · Agencia BTL en Lima, Perú: activaciones, eventos corporativos, trade marketing e intervención urbana con ejecución ordenada.",
};

export function whatsappHref(msg: string = SITE.whatsappMsg) {
  return `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;
}

export const SERVICES = [
  {
    slug: "/activaciones-btl",
    name: "Activaciones BTL",
    short:
      "Activaciones BTL y activaciones de marca en calle, punto de venta y eventos masivos en Lima.",
  },
  {
    slug: "/eventos-corporativos",
    name: "Eventos corporativos",
    short:
      "Producción de eventos corporativos en Lima: lanzamientos de marca, kick-offs, convenciones y reuniones.",
  },
  {
    slug: "/impulsadoras-promotoras",
    name: "Impulsadoras y promotoras",
    short:
      "Impulsación con impulsadoras, promotoras y personal promocional para activaciones BTL y eventos.",
  },
  {
    slug: "/anfitrionas",
    name: "Anfitrionas para eventos",
    short:
      "Anfitrionas para eventos corporativos, ferias y lanzamientos en Lima: recepción, registro y protocolo.",
  },
  {
    slug: "/sampling-degustaciones",
    name: "Sampling y degustaciones",
    short:
      "Campañas de sampling y degustaciones en punto de venta, calle y oficinas con rutas planificadas.",
  },
  {
    slug: "/trade-marketing",
    name: "Trade marketing",
    short:
      "Trade marketing en canal moderno y tradicional: material POP, exhibiciones y campañas en punto de venta.",
  },
  {
    slug: "/volanteo-publicitario",
    name: "Volanteo publicitario",
    short:
      "Volanteo publicitario y volanteo corporativo en Lima: street marketing y campañas de difusión por zona.",
  },
  {
    slug: "/merchandising-corporativo",
    name: "Merchandising corporativo",
    short:
      "Merchandising para empresas: artículos promocionales, textiles, regalos corporativos y material POP con tu logo.",
  },
  {
    slug: "/stands-para-ferias",
    name: "Stands para ferias",
    short:
      "Stands para ferias y exposiciones: a medida, modulares, portátiles y en alquiler, con diseño, montaje y desmontaje.",
  },
] as const;

export type ServiceSlug = (typeof SERVICES)[number]["slug"];
